import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const VerifyId: React.FC = () => (
  <PolicyPage slug="verify-id" subtitle="Verify ID" />
);

export default VerifyId;
